import { Text, Icon } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import { HelpLink } from './styles'

type HelpArticleButtonProps = {
  href: string
  children: any
  trackTappedHelpArticle?: () => Promise<any>
}

export const HelpArticleButton: React.SFC<HelpArticleButtonProps> = props => (
  <HelpLink
    styles={Text.Styles.Regular16}
    display={Text.DisplayModes.Flex}
    tag={'a'}
    onClick={props.trackTappedHelpArticle}
    href={props.href}
  >
    {props.children}
    <Icon
      type={Icon.Types.ChevronRight}
      size={Icon.Sizes.Medium}
      color={Icon.Colors.SystemGrey20}
    />
  </HelpLink>
)
const mapDispatchToProps = {
  trackTappedHelpArticle: events.trackTappedHelpArticle,
}

export default connect(null, mapDispatchToProps)(HelpArticleButton)
